module.exports = __webpack_public_path__ + "static/media/DSC_0023.7d3f1a9b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/people/DSC_0023.jpg
// module id = 617
// module chunks = 0